import { types, getRoot } from 'mobx-state-tree'

import USER_VALIDATIONS from '~/utilities/userValidations'
import buildCustomValidationStore from '~/stores/models/customValidation'

export const SearchContactInfoBaseStore = types
  .model('SearchContactInfoStore', {
    name: types.optional(types.string, ''),
    email: types.optional(types.string, ''),
    phoneNumber: types.optional(types.string, '')
  })
  .views(self => ({
    get user() {
      const root = getRoot(self)
      return root.auth.user
    },
  }))
  .actions(self => ({
    writePropertiesOnUser() {
      const user = self.user
      user.changeKey('name', self.name)
      user.changeKey('username', self.email)
      user.changeKey('email', self.email)
      user.changeKey('phoneNumber', self.phoneNumber)
      user.resetTouched()
    },
  }))

const CustomValidationStore = buildCustomValidationStore({
  validationObject: USER_VALIDATIONS
})

export const SearchContactInfoStore = types.compose(
  SearchContactInfoBaseStore,
  CustomValidationStore
)
